// extracted by mini-css-extract-plugin
export default {"content":"ReactModalWrap_content__JKhNT","collapseButton":"ReactModalWrap_collapseButton__tguYs"};